<template>
  <b-col sm="12" md="6">
    <b-input-group class="attribute" size="md" :prepend="name">
      <b-form-checkbox v-if="type == 'bool'" :name="name" @input="emitValue">
      </b-form-checkbox>
      <b-form-input v-if="type == 'string'" @input="emitValue"></b-form-input>
      <b-form-input
        v-if="type == 'int'"
        type="number"
        @input="emitValue"
      ></b-form-input>
      <b-form-select v-if="type == 'option'" @input="emitValue">
        <option v-for="option in options" :key="option" :value="option">{{
          option
        }}</option>
      </b-form-select>
      <b-form-input
        v-if="type == 'date'"
        type="date"
        @input="emitValue"
      ></b-form-input>
      <b-form-input
        v-if="type == 'time'"
        type="time"
        @input="emitValue"
      ></b-form-input>
      <div v-if="type == 'object'">
        <b-input-group
          v-for="prop in properties"
          :key="prop"
          class="attribute"
          size="md"
          :prepend="prop.name"
        >
          <b-form-input
            :key="prop"
            :type="prop.type"
            @change="emitArray"
          ></b-form-input>
        </b-input-group>
      </div>
      <div v-if="type == 'array'">
        <b-form-input
          v-for="num in totalUserGeneratedOptions"
          :key="num"
          type="text"
          :placeholder="`${name} ${num + 1}`"
          @change="emitArray"
        ></b-form-input>
        <v-btn class="mx-2" fab dark small @click="addNewItem" color="indigo">
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
      </div>
    </b-input-group>
  </b-col>
</template>

<script>
export default {
  data() {
    return { totalUserGeneratedOptions: 0, userGeneratedOptions: [""] };
  },
  props: { name: String, type: String, options: Array, properties: Array },
  methods: {
    emitValue(value) {
      this.$emit("change", {
        name: this.name,
        value:
          this.type == "int"
            ? parseInt(value)
            : this.type == "date"
            ? new Date(value)
            : value
      });
    },
    emitArray(value) {
      this.userGeneratedOptions.push(value);
      this.$emit("change", {
        name: this.name,
        value: this.userGeneratedOptions
      });
    },
    addNewItem() {
      this.totalUserGeneratedOptions++;
    }
  }
};
</script>

<style>
.attribute {
  margin: 10px 0px 0px 0px;
}
</style>
